import React from 'react';

import { fields } from '../../shared/models/otherLocation';
import useCollectionSubscription from '../hooks/useCollectionSubscription';
import ModelFormModal from '../modals/ModelFormModal';
import Page from '../hocs/Page';
import AddButton from '../AddButton';
import EditButton from '../EditButton';
import DeleteButton from '../DeleteButton';
import SettingsTabs from '../SettingsTabs';

export default Page(function SettingsOtherLocations (props) {
  const { tenant } = props;
  const otherLocationsRef = tenant.ref.collection('otherLocations');
  const otherLocations = useCollectionSubscription(otherLocationsRef.orderBy('createdAt'), [tenant.id]);

  return (
    <div className="settings-other-locations container-fluid">
      <div className="p-4 bg-white my-4">
        <SettingsTabs activeTab="otherLocations" />
        <div className="alert alert-info">
          在庫ロケーションを複数登録します。
        </div>
        <div className="d-flex justify-content-start mb-3">
          <AddButton itemRef={otherLocationsRef.doc()} FormModal={ModelFormModal} formProps={{ title: 'ロケーション 追加', fields: fields({ otherLocations }), }} />
        </div>
        <div className="mt-3 overflow-auto">
          {
            otherLocations.length > 0 ? (
              <table className="table sticky-table table-sm table-bordered">
                <thead className="thead-light text-center">
                  <tr className="text-nowrap">
                    <th style={{ minWidth: 200 }}>キー</th>
                    <th style={{ minWidth: 200 }}>名称</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {
                    otherLocations.map((otherLocation) => {
                      const { id, ref, sortKey, name, } = otherLocation;

                      return (
                        <tr key={id}>
                          <td>
                            {sortKey}
                          </td>
                          <td>
                            {name}
                          </td>
                          <td className="text-right text-nowrap">
                            <EditButton className="ml-2" itemRef={ref} FormModal={ModelFormModal} formProps={{ title: 'ロケーション 編集', fields: fields({ otherLocations: otherLocations.filter(_ => _.id !== id) }), }} />
                            <DeleteButton item={otherLocation} itemRef={ref} className="ml-2" />
                          </td>
                        </tr>
                      );
                    })
                  }
                </tbody>
              </table>
            ) : (
              <div>
                ロケーションは未登録です
              </div>
            )
          }
        </div>
      </div>
    </div>
  );
});
